export default {
  welcome: "お帰りなさい、{email}",
  subtitle:
    "ここであなたのアカウントを管理し、サブスクリプション情報を表示できます。",
  currentPlan: "現在のプラン",
  usageStatistics: "使用量",
  manageTitle: "プランを管理",
  monthlyImages: "月間画像",
  monthlyCredits: "月間クレジット",
  trialCredits: "永続クレジット",
  validPeriod: "有効期間",
  monthlyUsage: "月間使用",
  trialUsage: "永続使用",
  uploadNewImage: "新しい画像をアップロード",
  viewHistory: "履歴を表示",
  getSupport: "サポートを受ける",
  upgradeButton: "プランをアップグレード",
  currentPlanBadge: "現在のプラン",
  unlimitedUsage: "無制限に利用可能",
  limitReached: "月間制限に達しました",
  creditsUnit: "クレジット",
  imagesRemaining: "今月は残り{count}クレジット利用可能",
  onlyRemaining: "今月は残り{count}クレジットのみ利用可能",
  planType: "プランの種類",
  billingPeriod: "請求周期",
  billingPeriodMonthly: "月額",
  billingPeriodAnnual: "年額",
  billingPeriodOneTime: "一回限り",
  billingPeriodUnknown: "--",
  planCancelAtPeriodEndNotice: "現在の期間が終了するまでプランは有効です。",
  creditTotalAvailable: "利用可能総数",
  creditRemainingGranted: "残り {remaining} / 上限 {granted}",
  creditUsed: "使用済み {used}",
  creditValidityRange: "有効期間 {start} – {end}",
  cycleCreditsUnavailable: "現在有効な月間クレジットサイクルはありません",
  downgradeButton: "ダウングレード",
  plans: {
    free: {
      title: "フリー",
      price: "$0",
      period: "/月",
      features: {
        0: "登録で15クレジット",
        1: "元画像と参考画像の差異分析",
        2: "AI編集ガイド",
        3: "基本分析機能無料",
        4: "一部高度分析機能はクレジットでアンロック",
        5: "履歴5件",
      },
    },
    standard: {
      title: "スタンダード",
      price: "$9.99",
      period: "/月",
      features: {
        0: "月90クレジット",
        1: "差異分析可視化はクレジットでアンロック",
        2: "ピクセルインスペクター、カラーパレット分析機能はクレジットでアンロック",
        3: "履歴100件",
        4: "クレジット追加パック対応",
        5: "未使用クレジットは契約中1請求サイクル繰越",
      },
      subtitle: "フリープランの全機能、そして",
    },
    pro: {
      title: "プロ",
      price: "$18.99",
      period: "/月",
      badge: "最も人気",
      features: {
        0: "月200クレジット",
        6: "差異分析可視化無料",
        1: "ピクセルインスペクター無料",
        2: "カラーパレット分析無料",
        3: "Pro専用機能無料：輝度/RGB 精密可視化マッピング",
        4: "履歴300件",
        5: "未使用クレジットは契約中1請求サイクル繰越",
      },
      subtitle: "スタンダード版の全機能、そして",
    },
  },
  buttonText: {
    currentPlan: "現在のプラン",
    upgrade: "アップグレード",
    unavailable: "利用不可",
    managePlan: "プラン管理",
    oneOff: "一括購入",
    periodUnavailable: "この請求周期は利用できません",
  },
  billingErrors: {
    checkoutConflict:
      "すでに有効なサブスクリプションがあります。管理画面で変更してください。",
    oneOffConflict:
      "すでに有効なクレジットがあります。有効期限後に購入してください。",
    portalForbidden: "サブスクリプションのみ管理画面を利用できます。",
    confirmNotPaid: "支払いの確認中です。後ほど更新してください。",
    confirmFailed: "支払い確認に失敗しました。後ほど再試行してください。",
    statusUnavailable:
      "支払い状況が一時的に利用できません。後ほど再試行してください。",
    statusSyncFailed:
      "課金ステータスの読み込みに失敗しました。購入は一時的に無効化されています。再試行してください。",
    statusAuthError:
      "セッションの有効期限が切れました。課金を管理するには再度ログインしてください。",
    checkoutUrlMissing:
      "チェックアウトを開始できませんでした。もう一度お試しください。",
    checkoutCreateFailed:
      "チェックアウトの作成に失敗しました。後ほど再試行してください。",
    portalUrlMissing:
      "請求ポータルを開けませんでした。もう一度お試しください。",
    portalCreateFailed:
      "請求ポータルの作成に失敗しました。後ほど再試行してください。",
    externalRedirect:
      "リダイレクトを完了できませんでした。もう一度お試しいただくか、サポートにお問い合わせください。",
    externalRedirectBlocked:
      "この決済リンクは不安全な可能性があるためブロックされました。サポートにお問い合わせください。",
  },
  statusBanner: {
    syncFailed: "課金ステータスの読み込みに失敗しました。回復するまで購入は一時停止されます。",
    authError: "セッションの有効期限が切れました。続行するには再度ログインしてください。",
    retry: "再試行",
    loginAction: "ログイン",
    returnPending: "お支払いを確認中です。再試行するか、ページを更新してください。",
    returnPendingRetry: "再確認",
    dismiss: "閉じる",
  },
  status: {
    paid: "有効",
    trial: "トライアル",
    expired: "期限切れ",
  },
  paymentCancel: {
    title: "お支払いはキャンセルされました",
    description1: "お支払いはキャンセルされました。",
    description2: "ダッシュボードに戻って PhotoScope を引き続きご利用いただけます。",
    backToDashboard: "ダッシュボードに戻る",
    resumePlans: "プランを引き続きご覧になる"
  },
};
